/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import handlebars from 'handlebars';
import lodash from 'lodash';
import { IGeneratorOptions } from '../models/generator-options.ts';
import { ITemplateData } from '../models/template-data.ts';
import { IEntity } from '../models/entity.ts';
import { IValueProperty } from '../models/value-property.ts';
import { BaseGenerator } from './base.generator.ts';
import { IHelperContext, PropertyType } from '../models/helper-context.ts';

export class FormGroupFactoryGenerator extends BaseGenerator<IEntity> {
  public readonly GeneratorName = 'FormGroupFactoryGenerator';
  constructor(options: IGeneratorOptions) {
    super(options, options.templates?.formGroupFactory);
  }

  public generate(templateData: ITemplateData): void {
    this.registerHelpers();
    templateData.entities
      ?.filter((val) => val.valueProperties?.length + val.referenceProperties?.length > 0)
      .forEach((entity) => {
        super.generateFile(`${this.generatorOptions.outputPath}/${lodash.kebabCase(entity.name)}.form-group-fac.ts`, entity);
      });
  }
  public registerHelpers() {
    this.registerValidatorHelper('minimum', 'min');
    this.registerValidatorHelper('maximum', 'max');
    this.registerValidatorHelper('minLength');
    this.registerValidatorHelper('maxLength');
    this.registerValidatorHelper('maxItems', 'maxLength');
    this.registerValidatorHelper('minItems', 'minLength');
    this.registerValidatorHelper('pattern');
  }

  public registerValidatorHelper(validatorName: string, angularValidatorName: string = validatorName): void {
    handlebars.registerHelper(`${validatorName}Validator`, (x: PropertyType, y: IHelperContext) =>
      this.validatorFactory(x, y, validatorName, angularValidatorName),
    );
  }

  public validatorFactory(
    propertyCollection: PropertyType,
    propertyContext: IHelperContext,
    validationName: string,
    angularValidatorFunctionName: string,
  ) {
    const props = propertyContext.data.root[propertyCollection] as IValueProperty[];
    const prop = props[propertyContext.data.index];
    let value = prop[validationName as keyof typeof prop] as number | string | undefined;
    if (value !== undefined && value !== null) {
      const hasMultipleValidators = prop.hasMultipleValidators;
      value = typeof value === 'string' ? `'${value}'` : value;
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      return `Validators.${angularValidatorFunctionName}(${value})${hasMultipleValidators ? ', ' : ''}`;
    }
    return '';
  }
}
